"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Request {
    constructor() {
        const { common: { request: { get: ajaxGet, post: ajaxPost, bindCommonApi }, behavior: { runBehaviour }, }, } = require('@futuweb/fego-render');
        this.get = ajaxGet;
        this.post = ajaxPost;
        this.runBehaviour = runBehaviour;
        this.bindCommonApi = bindCommonApi;
    }
    needLoginWrapper(res) {
        if (res.code === 10002) {
            this.runBehaviour(this, {
                type: 'login',
                value: location.href,
                withQuery: true,
            });
        }
        else {
            return res;
        }
    }
}
exports.default = new Request();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlcXVlc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxNQUFNLE9BQU87SUFLVDtRQUNJLE1BQU0sRUFDRixNQUFNLEVBQUUsRUFDSixPQUFPLEVBQUUsRUFBRSxHQUFHLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxRQUFRLEVBQUUsYUFBYSxFQUFFLEVBQ3hELFFBQVEsRUFBRSxFQUFFLFlBQVksRUFBRSxHQUM3QixHQUNKLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUM7UUFDcEMsSUFBSSxDQUFDLEdBQUcsR0FBRyxPQUFPLENBQUM7UUFDbkIsSUFBSSxDQUFDLElBQUksR0FBRyxRQUFRLENBQUM7UUFDckIsSUFBSSxDQUFDLFlBQVksR0FBRyxZQUFZLENBQUM7UUFDakMsSUFBSSxDQUFDLGFBQWEsR0FBRyxhQUFhLENBQUM7SUFDdkMsQ0FBQztJQUVELGdCQUFnQixDQUFDLEdBQVE7UUFDckIsSUFBSSxHQUFHLENBQUMsSUFBSSxLQUFLLEtBQUssRUFBRTtZQUNwQixJQUFJLENBQUMsWUFBWSxDQUFDLElBQUksRUFBRTtnQkFDcEIsSUFBSSxFQUFFLE9BQU87Z0JBQ2IsS0FBSyxFQUFFLFFBQVEsQ0FBQyxJQUFJO2dCQUNwQixTQUFTLEVBQUUsSUFBSTthQUNsQixDQUFDLENBQUM7U0FDTjthQUFNO1lBQ0gsT0FBTyxHQUFHLENBQUM7U0FDZDtJQUNMLENBQUM7Q0FDSjtBQUVELGtCQUFlLElBQUksT0FBTyxFQUFFLENBQUMifQ==